import { render, staticRenderFns } from "./aadhar_upload.vue?vue&type=template&id=ab8463ee&"
import script from "./aadhar_upload.vue?vue&type=script&lang=js&"
export * from "./aadhar_upload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports